import ga from "@toolkit/Framework/Common/GoogleAnalytics";

const mapInvoiceOption = (options: Toolkit.GoogleAnalytics.Options | undefined): Toolkit.GoogleAnalytics.Event => {
    if (!options?.invoice) {
        return {};
    }

    const { invoice } = options;

    return {
        item_list_id: invoice.invoiceNumber,
        items: !options?.skipOptionItems ? ga.map.items(invoice.invoiceLines) : undefined,
        shipping: invoice.shippingAndHandling,
        tax: invoice.taxAmount,
        value: invoice.invoiceTotal,
    };
};

export default mapInvoiceOption;
